import { AsyncPipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { CartActions, MultiCartService } from '@spartacus/cart/base/core';
import {
  AuthService,
  BaseSiteService,
  GlobalMessageService,
  GlobalMessageType,
  TranslatePipe,
  UserIdService,
} from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { BaseSiteConfigService } from 'src/app/service/base-site/base-site-config.service';
import { ShimanoBusinessTypeService } from 'src/app/service/businessType/shimano-business-type.service';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { GoogleTagManagerService } from 'src/app/service/googletagmanager/google-tag-manager.service';
import { MyaccountPersonalInfoService } from 'src/app/service/myaccount/myaccount-personal-info.service';
import { OrderConfirmationPayload, OrderConfirmationService } from 'src/app/service/orders/order-confirmation.service';
import { PaymentService } from 'src/app/service/payment/payment.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatProgressSpinner, AsyncPipe, TranslatePipe],
})
export class OrderConfirmationComponent implements OnInit, OnDestroy, AfterViewInit {
  order$: Observable<any>;
  orderId: string;
  cartId: any;
  showConformationText: boolean;
  showCompanyName: boolean;
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  baseSite$: Observable<string> = this.baseService.getActive();
  globalMsg = document.querySelector('cx-global-message');
  payload: OrderConfirmationPayload = {
    orderCode: '',
    fields: 'FULL',
    user: this.userCurrent,
  };
  hideRefNumSubscription: Subscription;
  hideRefNumEnabled: boolean;

  constructor(
    private orderConfirmationService: OrderConfirmationService,
    private route: ActivatedRoute,
    private cartExtendService: CartExtendService,
    protected store: Store<MultiCartService>,
    private auth: AuthService,
    private userIdService: UserIdService,
    private globalMessageService: GlobalMessageService,
    private cdr: ChangeDetectorRef,
    private gtmService: GoogleTagManagerService,
    private baseService: BaseSiteService,
    private shimanoBusinessTypeService: ShimanoBusinessTypeService,
    private baseSiteConfigService: BaseSiteConfigService,
    private shimanoCountryService: ShimanoCountryService,
    private myAccountPersonalInforService: MyaccountPersonalInfoService,
    private storageService: StorageService,
    private paymentService: PaymentService
  ) {
    this.globalMsg.classList.add('inactive');
    this.globalMsg.setAttribute('id', 'hideCxGlobalMessage');
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      /* tslint:disable:no-string-literal */
      this.orderId = params['code'];
      this.payload.orderCode = this.orderId;
    });

    this.orderConfirmationService
      .getOrderConfirmationConfig()
      .pipe(take(1))
      .subscribe((resp: any) => {
        this.showConformationText =
          resp.showConformationText[this.businessType][this.country] !== undefined
            ? resp.showConformationText[this.businessType][this.country]
            : resp.showConformationText[this.businessType]['default'];

        this.showCompanyName =
          resp.showCompanyName[this.businessType][this.country] !== undefined
            ? resp.showCompanyName[this.businessType][this.country]
            : resp.showCompanyName[this.businessType]['default'];

        this.cdr.detectChanges();
      });
  }
  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }
  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get businessType(): string {
    let businessType: string;
    this.shimanoBusinessTypeService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (businessType = data));
    return businessType;
  }

  get country(): string {
    let country: string;
    this.shimanoCountryService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (country = data));
    return country;
  }
  ngOnInit() {
    this.cartExtendService
      .getCurrentCart()
      .pipe(
        take(1),
        switchMap((data) => {
          this.store.dispatch(
            new CartActions.LoadCart({
              userId: this.userCurrent,
              cartId: data.code,
              extraData: {
                active: true,
              },
            })
          );
          return this.paymentService.verifyPayment(data.code);
        })
      )
      .subscribe();
    this.order$ = this.orderConfirmationService.getConfirmationOrder(this.payload).pipe(
      filter(Boolean),
      map((p: any) => p),
      tap(() => {
        this.gtmPurchase();
      })
    );

    this.isHideRefNumEnabled();
  }

  gtmPurchase() {
    const gtmPurchase: any = JSON.parse(this.storageService.getSessionStorageItem('gtmPurchase'));
    if (gtmPurchase) {
      gtmPurchase.ecommerce.transaction_id = this.orderId;
      this.gtmService.pushTag({ ecommerce: null });
      this.gtmService.pushTag(gtmPurchase);
      this.storageService.removeSessionStorageItem('gtmPurchase');
    }
  }

  ngAfterViewInit() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.cdr.detectChanges();
  }

  isHideRefNumEnabled = () => {
    this.hideRefNumSubscription = this.getHideRefNumConfig$().subscribe((refNum) => {
      this.hideRefNumEnabled = refNum === 'true';
      this.cdr.detectChanges();
    });
  };

  getHideRefNumConfig$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.hide.reference.number.enabled'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.hide.reference.number.enabled')
              .map((res: any) => res.value)[0]
        )
      );
  }
  showAddress(addresses: any): Observable<string> {
    return this.myAccountPersonalInforService.formatAddress(addresses);
  }

  ngOnDestroy() {
    this.globalMsg.removeAttribute('id');
  }
}
